import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { StatusSubset } from "../types";

const FILTER_OPTIONS = {
  active: [
    {
      id: "CASE_ORDERED",
      name: "Case ordered",
    },
    {
      id: "APPLICANT_INVITED",
      name: "Applicant invited",
    },
    {
      id: "APPLICANT_OPENED",
      name: "Applicant opened",
    },
    {
      id: "APPLICANT_STARTED",
      name: "Applicant started",
    },
    {
      id: "IN_PROGRESS",
      name: "In progress",
    },
    {
      id: "CLIENT_ACTION_REQUIRED",
      name: "Client action required",
    },
    {
      id: "APPLICANT_ACTION_REQUIRED",
      name: "Applicant action required",
    },
    {
      id: "IN_DISPUTE",
      name: "In dispute",
    },
  ],
  review: [
    {
      id: "COMPLETE",
      name: "Complete",
    },
  ],
  done: [
    {
      id: "INVITE_UNDELIVERABLE",
      name: "Invite undeliverable",
    },
    {
      id: "APPLICANT_DECLINED",
      name: "Applicant declined",
    },
    {
      id: "APPLICANT_EXPIRED",
      name: "Applicant expired",
    },
    {
      id: "CANCELLED",
      name: "Cancelled",
    },
    {
      id: "COMPLETE",
      name: "Complete",
    },
  ],
};

// TODO: adjust picker to allow us to render status tags as options instead of just text
export function StatusFilter(props: { statusSubset: StatusSubset }) {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.overall_status?.split(",") || []}
      onSelectionChange={(keys) => setParam("overall_status", Array.from(keys))}
      label={t("Status")}
      items={(
        FILTER_OPTIONS[props.statusSubset as keyof typeof FILTER_OPTIONS] || []
      ).map((status: { id: string; name: string }) => ({
        id: status.id,
        name: status.name,
      }))}
      selectionMode="multiple"
      testID="status-filter"
    />
  );
}
